import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Stack,
  Typography,
  Tooltip,
  IconButton,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Box } from '@mui/system';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import { useDispatch } from 'react-redux';
import { FcApproval } from 'react-icons/fc';
import { MdSpellcheck, MdCheckBox, MdThumbDown } from 'react-icons/md';
import { BsTelephone } from 'react-icons/bs';
import { GiModernCity } from 'react-icons/gi';
// material icons
import DeckIcon from '@mui/icons-material/Deck';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmergencyShareIcon from '@mui/icons-material/EmergencyShare';
import VillaIcon from '@mui/icons-material/Villa';
import { BiCloudDownload } from 'react-icons/bi';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import {
  checkDataApi,
  downloadApiData,
  getPartnerStatusType,
  PreviewImageApi,
  saveApiData
} from '../../store/Slice/Global/GlobalSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { getOnboardingView } from '../../store/Slice/Onboarding/OnboardingSlice';
import { OnboardingApi } from '../../utils/Apis';
import { isValidValue, normalizeValue } from '../../utils/CommonFunction';
import { NOT_AVAILABLE } from '../Global/Constants';
import cancelChequeDummy from './dummy/cancelChequeDummy.png';
import photoDummy from './dummy/photoDummy.jpg';
import aadharFrontDummy from './dummy/aadharFrontDummy.jpg';
import panCardDummy from './dummy/panCardDummy.jpg';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function ReviewOnBoarding() {
  const [pageNumber, setPageNumber] = useState(1); // setting 1 to show fisrt page
  const [chequePreview, setChequePreview] = useState(cancelChequeDummy);
  const [photoPreview, setPhotoPreview] = useState(photoDummy);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(aadharFrontDummy);
  const [panPreview, setPanPreview] = useState(panCardDummy);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [previewFileType, setPreviewFileType] = useState('image');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { rowId } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const { PartnerStatusTypes } = useGlobalSelector();
  const { OnboardingViewData: reviewData } = useOnboardingSelector();

  // console.log('reviewData', reviewData);

  useEffect(() => {
    dispatch(getPartnerStatusType());
  }, []);

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setPageNumber(1);
  }, []);

  const fireUpdateStateApi = useCallback(
    async (typeid) => {
      if (!typeid) return;
      try {
        const statusCredential = {
          companyId: LoginData?.companyId,
          partnerId: rowId,
          partnerStatusTypeId: typeid
        };
        const result = await dispatch(saveApiData(OnboardingApi?.onboardUpdate, statusCredential));
        if (result?.status === 'success') navigate('/onboarding');
      } catch (error) {
        console.error('Failed to update partner status', error);
      }
    },
    [LoginData, rowId, dispatch, navigate]
  );

  // const getOnBoardView = useCallback(() => {
  //   if (LoginData?.companyId && rowId) {
  //     const credential = {
  //       companyId: LoginData?.companyId,
  //       partnerId: rowId
  //     };
  //     // dispatch(getOnboardingView(credential));
  //     const result = dispatch(getOnboardingView(credential));
  //     console.log('sss getOnBoardView result', result);
  //   }
  // }, [LoginData, rowId]);

  useEffect(() => {
    const credential = {
      companyId: LoginData?.companyId || '',
      partnerId: rowId
    };
    dispatch(getOnboardingView(credential));
  }, []);

  const isIndividual = reviewData?.typeId === 66;

  const infoFields = useMemo(
    () => [
      {
        icon: <DeckIcon className="viewLabelIcon" size={24} />,
        label: 'Partner Type',
        value: normalizeValue(reviewData?.partnerType?.typeCode, NOT_AVAILABLE)
      },
      {
        icon: <GroupIcon className="viewLabelIcon" size={24} />,
        label: isIndividual ? 'Name' : 'Company Name',
        value: normalizeValue(reviewData?.partnerName, NOT_AVAILABLE)
      },
      {
        icon: <PersonIcon className="viewLabelIcon" size={24} />,
        label: isIndividual ? "Father's Name" : 'Authorised Person Name',
        value: normalizeValue(
          isIndividual ? reviewData?.fathersName : reviewData?.authorisedPersonName,
          NOT_AVAILABLE
        )
      },
      {
        icon: <CalendarMonthIcon className="viewLabelIcon" size={24} />,
        label: isIndividual ? 'DOB' : 'Date of Incorporation',
        value: normalizeValue(reviewData?.dob, NOT_AVAILABLE)
      },
      {
        icon: <BsTelephone className="viewLabelIcon" size={24} />,
        label: 'Phone',
        value: normalizeValue(reviewData?.mobile, NOT_AVAILABLE)
      },
      {
        icon: <EmergencyShareIcon className="viewLabelIcon" size={24} />,
        label: 'Address',
        value: normalizeValue(reviewData?.address, NOT_AVAILABLE)
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'City',
        value: normalizeValue(reviewData?.cityEntity?.cityName, NOT_AVAILABLE)
      },
      {
        icon: <VillaIcon className="viewLabelIcon" size={24} />,
        label: 'State',
        value: normalizeValue(reviewData?.stateEntity?.stateName, NOT_AVAILABLE)
      },
      {
        icon: <VillaIcon className="viewLabelIcon" size={24} />,
        label: 'Email Id',
        value: normalizeValue(reviewData?.emailAddress, NOT_AVAILABLE)
      }
    ],
    [reviewData, isIndividual]
  );

  async function handlePreviewDoc(partnerDocumentId) {
    const { partnerId, companyId } = reviewData;

    const blob = await dispatch(
      PreviewImageApi(
        `pdoc/${companyId}/${partnerId}/${partnerDocumentId}`,
        null,
        true // 👈 blob mode
      )
    );

    if (!blob) return;

    setPreviewFileType(blob.type === 'application/pdf' ? 'pdf' : 'image');
    const fileURL = URL.createObjectURL(blob);
    setPreviewUrl(fileURL);
    setOpenPreview(true);
  }

  async function handleDownloadDoc(partnerDocumentId, fileName = 'document') {
    const { partnerId, companyId } = reviewData;
    const blob = await dispatch(
      PreviewImageApi(`pdoc/${companyId}/${partnerId}/${partnerDocumentId}`, null, true)
    );

    if (!blob) return;

    const extension = blob.type === 'application/pdf' ? 'pdf' : 'png';
    const fileURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${fileName}.${extension}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    URL.revokeObjectURL(fileURL);
  }

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.2, 3)); // Max zoom 3x
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.2, 1)); // Min zoom 1x
  };

  const handleResetZoom = () => {
    setZoomLevel(1);
  };

  // ✅ Handle double-click to toggle zoom
  const handleDoubleClick = () => {
    if (zoomLevel === 1) {
      setZoomLevel(2); // Zoom to 2x on double-click
    } else {
      setZoomLevel(1); // Reset to 1x on double-click again
    }
  };

  return (
    <Page title="Kpros by Kalolytic Solutions || On Boarding">
      <Container maxWidth="xl">
        {reviewData && (
          <Box pt={3} pb={3} mb={4}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              className="pageHeading"
            >
              <PageTitle info="Review" />
              <Box>
                <BrudCrumbs />
              </Box>
            </Stack>
            {/* {console.log('sss PartnerStatusTypes', PartnerStatusTypes)} */}
            <Box className="submitLeadToolbar" mb={1}>
              {PartnerStatusTypes?.length > 0 &&
                PartnerStatusTypes?.map((status, index) => {
                  if (status?.typeCode === 'APPROVED') {
                    return (
                      <>
                        <Tooltip key={index} title={status?.typeName} placement="top" arrow>
                          <IconButton
                            className="squareIconButton"
                            onClick={(e) => fireUpdateStateApi(status?.typeId)}
                          >
                            {status?.typeName === 'Approved' && <MdCheckBox size={18} />}
                          </IconButton>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;
                      </>
                    );
                  }
                  if (status?.typeCode === 'REJECTED') {
                    return (
                      <>
                        <Tooltip key={index} title={status?.typeName} placement="top" arrow>
                          <IconButton
                            className="squareIconButton"
                            onClick={(e) => fireUpdateStateApi(status?.typeId)}
                          >
                            {status?.typeName === 'Rejected' && <MdThumbDown size={18} />}
                          </IconButton>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;
                      </>
                    );
                  }
                  if (status?.typeCode === 'ACTIVATED') {
                    return (
                      <>
                        <Tooltip key={index} title={status?.typeName} placement="top" arrow>
                          <IconButton
                            className="squareIconButton"
                            onClick={(e) => fireUpdateStateApi(status?.typeId)}
                            disabled={
                              !(
                                reviewData?.partnerStatus?.typeCode === 'ACTIVATED' ||
                                reviewData?.partnerStatus?.typeCode === 'APPROVED'
                              )
                            }
                          >
                            {status?.typeName === 'Activated' && <MdSpellcheck size={18} />}
                          </IconButton>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;
                      </>
                    );
                  }
                  return true;
                })}
            </Box>

            <Typography variant="body1" className="headingLineUp headingLineUpOut">
              Partner Details
            </Typography>
            <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
              <Grid container spacing={3}>
                <Grid item xs>
                  <Grid container spacing={3}>
                    {infoFields?.map((item, index) => (
                      <Grid item xs={4} key={index}>
                        <Box className="displayFlex">
                          {item?.icon}
                          <Box>
                            <Typography variant="body2" className="labelText">
                              {item?.label}
                            </Typography>
                            <Typography variant="subtitle2" className="labelValue">
                              {item?.value}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Typography variant="body1" className="headingLineUp headingLineUpOut">
              Document Verfication
            </Typography>
            {/* {console.log('sss reviewData', reviewData)} */}
            <Box className="viewLeadCard cardTopMinusMargin">
              <Grid container spacing={3} mb={3}>
                {reviewData?.partnerDocuments?.map((documentElements, index) => {
                  const docType = documentElements?.documentType?.typeCode;
                  const mapping = {
                    'USER IMAGE': { label: 'User Image', dummy: photoPreview },
                    CHEQUE: { label: 'Cancelled Cheque Image', dummy: chequePreview },
                    'AADHAR CARD': { label: 'Adhar Card Image', dummy: aadharFrontPreview },
                    'PAN CARD': { label: 'Pan Card Image', dummy: panPreview }
                  };

                  const config = mapping[docType];
                  if (!config) return null;

                  return (
                    <Grid item xs={12} sm={4} md={3} key={index}>
                      <Typography variant="body2" className="mb-1" align="center">
                        <strong>{config.label}</strong>
                      </Typography>

                      <Box
                        className="uploadDocBoxLabel uploadDocBoxLabelFull docPreviewBox"
                        onClick={() => handlePreviewDoc(documentElements?.partnerDocumentId)}
                      >
                        <Box className="previewIconsBox">
                          <Tooltip title="Preview">
                            <Box
                              className="previewEyeIcon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePreviewDoc(documentElements?.partnerDocumentId);
                              }}
                            >
                              <VisibilityIcon />
                            </Box>
                          </Tooltip>
                          <Tooltip title="Download">
                            <Box
                              className="previewEyeIcon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadDoc(
                                  documentElements?.partnerDocumentId,
                                  config.label
                                );
                              }}
                            >
                              <BiCloudDownload />
                            </Box>
                          </Tooltip>
                        </Box>
                        <img src={config.dummy} alt={config.label} className="previewImage" />
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Box>
        )}
      </Container>
      <Dialog
        open={openPreview}
        onClose={() => {
          setOpenPreview(false);
          handleResetZoom(); // Reset zoom when closing
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Document Preview</span>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Tooltip title="Zoom In">
                <IconButton size="small" onClick={handleZoomIn} disabled={zoomLevel >= 3}>
                  <ZoomInIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Zoom Out">
                <IconButton size="small" onClick={handleZoomOut} disabled={zoomLevel <= 1}>
                  <ZoomOutIcon />
                </IconButton>
              </Tooltip>
              <Typography variant="body2" sx={{ minWidth: 50, textAlign: 'center' }}>
                {Math.round(zoomLevel * 100)}%
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'auto'
          }}
        >
          {previewUrl && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              {previewFileType === 'pdf' ? (
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    bgcolor: '#f5f5f5',
                    p: 2,
                    borderRadius: 1,
                    overflow: 'auto',
                    maxHeight: '70vh'
                  }}
                >
                  <Document
                    file={previewUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<div>Loading PDF...</div>}
                  >
                    <Pages
                      pageNumber={pageNumber}
                      scale={zoomLevel}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
                </Box>
              ) : (
                <Box
                  component="img"
                  src={previewUrl}
                  alt="Preview"
                  onDoubleClick={handleDoubleClick}
                  sx={{
                    width: '100%',
                    maxHeight: 500,
                    objectFit: 'contain',
                    transform: `scale(${zoomLevel})`,
                    transition: 'transform 0.3s ease-in-out',
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': {
                      cursor: 'zoom-in'
                    }
                  }}
                />
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleResetZoom} variant="outlined" size="small">
            Reset Zoom
          </Button>
          <Button
            onClick={() => {
              setOpenPreview(false);
              handleResetZoom();
            }}
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
export default ReviewOnBoarding;
